/** Quiet, synthesized ambience. Audio starts only after an explicit user gesture. */
export class Ambience {
  private context: AudioContext | null = null;
  private gain: GainNode | null = null;
  private oscillators: OscillatorNode[] = [];
  private voices: GainNode[] = [];
  private disposed = false;
  enabled = false;
  get status(): AudioContextState | 'uninitialized' { return this.context?.state ?? 'uninitialized'; }

  async toggle(): Promise<boolean> {
    if (this.disposed) return false;
    if (!this.context) {
      this.context = new AudioContext();
      this.gain = this.context.createGain();
      this.gain.gain.value = 0;
      this.gain.connect(this.context.destination);
      for (const [i, frequency] of [55, 82.41, 110, 164.81, 220.3].entries()) {
        const oscillator = this.context.createOscillator();
        oscillator.type = 'sine'; oscillator.frequency.value = frequency;
        const voice = this.context.createGain(); voice.gain.value = .075 / (i + 1);
        oscillator.connect(voice); voice.connect(this.gain); oscillator.start();
        this.oscillators.push(oscillator);
        this.voices.push(voice);
      }
    }
    await this.context.resume();
    if (this.disposed) return false;
    this.enabled = !this.enabled;
    this.gain!.gain.setTargetAtTime(this.enabled ? .35 : 0, this.context.currentTime, .5);
    return this.enabled;
  }
  async setHidden(hidden: boolean): Promise<void> {
    if (!this.context || this.context.state === 'closed') return;
    if (hidden) await this.context.suspend();
    else if (this.enabled) await this.context.resume();
  }
  dispose(): void {
    if (this.disposed) return;
    this.disposed = true;
    this.oscillators.forEach((oscillator) => oscillator.stop());
    this.oscillators.forEach((oscillator) => oscillator.disconnect());
    this.voices.forEach(voice => voice.disconnect()); this.voices = [];
    this.oscillators = [];
    this.gain?.disconnect();
    this.gain = null;
    this.enabled = false;
    void this.context?.close();
    this.context = null;
  }
}
